import React from 'react';

import { IconParams, Icons } from 'widget/components';
import { useMsgContext } from '../../msg-context';

const params: IconParams = {
  className: 'whatcrm-widget-message__ack',
  fill: 'dark',
  size: 24,
};

const Ack = () => {
  const { msg } = useMsgContext();

  return (
    <>
      {msg.status == 'delivered' || msg.status == 'sent' ? (
        <Icons.Ack {...params} />
      ) : (
        msg.status == 'read' && <Icons.Acks {...params} />
      )}
    </>
  );
};

export default Ack;
